import React from 'react';
import { AlignedListRoot, AlignedListElementContainer } from './AlignedList.styles';

type AlignedListProps = {
  listElements: React.ReactNode[]
  paddingY?: number
}

export const AlignedList: React.FC<AlignedListProps> = ({ listElements, paddingY = 32 }) => {
  return (
    <AlignedListRoot>
      {
        listElements.map((element, index) => (
          <AlignedListElementContainer  css={{
            padding: `${paddingY}px 0px`,
          }} key={index}>
            {element}
          </AlignedListElementContainer>
        ))
      }
    </AlignedListRoot>
  );
};
